import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

import { Column } from 'components/v2/Column'
import Heading from 'components/v2/Heading'
import { InputNumber } from 'components/InputNumber'
import { Row } from 'components/v2/Row'
import { IOdometerFormValues } from 'features/Vehicles/types'
import { Label } from 'components/v2/Label'

const messages = defineMessages({
  odometerReadingPlaceholder: {
    id: 'vehicles.form.odometer.placeholder',
    defaultMessage: 'KM'
  }
})

export const OdometerForm = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue, handleBlur, touched, errors } = useFormikContext<IOdometerFormValues>()

  return (
    <>
      <Heading.H4>
        <FormattedMessage id="vehicles.form.odometer.title" defaultMessage="Odometer" />
      </Heading.H4>
      <Row noMargin>
        <Column width="50%">
          <Label optional>
            <FormattedMessage id="vehicles.form.odometerReading.label" defaultMessage="Current reading" />
          </Label>
          <InputNumber
            id="odometerReading"
            onChange={(value: string): void => {
              if (value) {
                setFieldValue('odometerReading', parseInt(value))
              } else {
                setFieldValue('odometerReading', null)
              }
            }}
            onBlur={handleBlur}
            value={values.odometerReading || ''}
            placeholder={intl.formatMessage(messages.odometerReadingPlaceholder)}
            touched={touched.odometerReading}
            errors={errors.odometerReading}
            maskOptions={{
              allowDecimal: false,
              suffix: ' km'
            }}
          />
        </Column>
      </Row>
    </>
  )
}
